// extracted by mini-css-extract-plugin
export default {"modalBody":"styles_modalBody__nwTzv","close":"styles_close__BlpJx","row":"styles_row__DwhvS","mobileLabel":"styles_mobileLabel__dGrS3"};